module.exports = __webpack_public_path__ + "static/img/main6.9a25f23.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/landing/main6.png
// module id = uXSf
// module chunks = 1